/**
 * Feature imports + tree. Login added in Phase 4.5; screens in 5/6/7 (plan §3.4).
 */
import { createRouter } from '@tanstack/react-router';

import { dashboardRoute } from '@/features/dashboard/route';
import { loginRoute } from '@/features/login/route';
import { sectorRoute } from '@/features/sector/route';
import { stockRoute } from '@/features/stock/route';

import { rootRoute } from './router-root';

const routeTree = rootRoute.addChildren([dashboardRoute, sectorRoute, stockRoute, loginRoute]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
